// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.content-hub-page {
    background: #ffffff;
    min-height: 100vh;
}

.content-hub-page-shell {
    padding-top: 132px;
    padding-bottom: 56px;
}

.content-hub-page-header {
    display: flex;
    justify-content: space-between;
    align-items: end;
    gap: 24px;
    margin-bottom: 28px;
    padding-bottom: 24px;
    border-bottom: 1px solid rgba(20, 24, 31, 0.08);
}

.content-hub-page-heading {
    max-width: 760px;
}

.content-hub-kicker {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 0.78rem;
    font-weight: 700;
    letter-spacing: 0.12em;
    text-transform: uppercase;
    color: var(--accent-red);
}

.content-hub-page-title,
.content-hub-detail-title {
    margin: 14px 0 12px;
    color: var(--text-main);
}

.content-hub-page-title {
    font-size: clamp(2.3rem, 4vw, 3.6rem);
    line-height: 1.08;
}

.content-hub-page-description {
    max-width: 720px;
    color: var(--text-light);
    font-size: 1rem;
    line-height: 1.78;
}

.content-hub-filter-bar {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    margin-bottom: 26px;
}

.content-hub-filter-pill,
.content-hub-page-button,
.content-hub-page-chip {
    border-radius: 999px;
    border: 1px solid rgba(217, 0, 27, 0.12);
    background: #ffffff;
    color: var(--text-main);
    font: inherit;
    cursor: pointer;
    transition: all 0.2s ease;
}

.content-hub-filter-pill {
    padding: 10px 18px;
    font-weight: 600;
}

.content-hub-filter-pill.is-active,
.content-hub-page-chip.is-active {
    background: var(--accent-red);
    color: #ffffff;
    border-color: var(--accent-red);
}

.content-hub-list {
    display: grid;
    gap: 22px;
}

.content-hub-list.is-resource {
    grid-template-columns: repeat(2, minmax(0, 1fr));
}

.content-hub-card {
    border-radius: 24px;
    border: 1px solid rgba(20, 24, 31, 0.08);
    background: #ffffff;
    box-shadow: 0 18px 42px rgba(17, 22, 31, 0.06);
    overflow: hidden;
}

.content-hub-card-link {
    display: grid;
    height: 100%;
    text-decoration: none;
    color: inherit;
}

.content-hub-card.is-news .content-hub-card-link {
    grid-template-columns: 280px minmax(0, 1fr);
}

.content-hub-card.is-resource .content-hub-card-link {
    grid-template-columns: 1fr;
}

.content-hub-card-visual,
.content-hub-detail-visual {
    position: relative;
    overflow: hidden;
}

.content-hub-card-visual.has-image,
.content-hub-detail-visual.has-image {
    background: #f5f5f5;
}

.content-hub-cover-image {
    width: 100%;
    height: 100%;
    display: block;
    object-fit: cover;
}

.content-hub-card.is-news .content-hub-card-visual {
    min-height: 100%;
}

.content-hub-card.is-resource .content-hub-card-visual {
    min-height: 220px;
}

.tone-news {
    background: linear-gradient(145deg, #fff4f5 0%, #f9dfe3 52%, #efbcc4 100%);
}

.tone-talent {
    background: linear-gradient(145deg, #fff8ec 0%, #f5e2be 50%, #e4c17d 100%);
}

.tone-experts {
    background: linear-gradient(145deg, #f1f6ff 0%, #d6e4fb 50%, #abc3ef 100%);
}

.tone-service-cases {
    background: linear-gradient(145deg, #f3faf6 0%, #d7eadf 50%, #add1bb 100%);
}

.content-hub-card-orb {
    position: absolute;
    width: 180px;
    height: 180px;
    border-radius: 50%;
    top: -50px;
    right: -36px;
    background: rgba(255, 255, 255, 0.36);
}

.content-hub-card-lines {
    position: absolute;
    left: 26px;
    right: 26px;
    bottom: 26px;
    display: grid;
    gap: 10px;
}

.content-hub-card-lines span {
    display: block;
    height: 10px;
    border-radius: 999px;
    background: rgba(255, 255, 255, 0.82);
}

.content-hub-card-lines .is-short {
    width: 56%;
}

.content-hub-card-copy {
    display: grid;
    align-content: start;
    gap: 14px;
    padding: 28px 30px;
}

.content-hub-card-meta,
.content-hub-detail-meta {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 10px 14px;
    font-size: 0.9rem;
    color: var(--text-light);
}

.content-hub-card-badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 6px 10px;
    border-radius: 999px;
    background: #fff1f2;
    color: var(--accent-red);
    font-size: 0.78rem;
    font-weight: 700;
    letter-spacing: 0.06em;
    text-transform: uppercase;
}

.content-hub-card-copy h2 {
    margin: 0;
    color: var(--text-main);
    font-size: 1.5rem;
    line-height: 1.32;
}

.content-hub-card-copy p,
.content-hub-detail-summary,
.content-hub-article p,
.content-hub-empty,
.content-hub-not-found p {
    color: var(--text-light);
    line-height: 1.84;
}

.content-hub-card-cta,
.content-hub-back-link {
    width: fit-content;
    color: var(--accent-red);
    font-weight: 700;
    text-decoration: none;
}

.content-hub-pagination {
    margin-top: 34px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
}

.content-hub-page-button {
    padding: 10px 16px;
}

.content-hub-page-button:disabled {
    opacity: 0.4;
    cursor: not-allowed;
}

.content-hub-page-list {
    display: flex;
    align-items: center;
    gap: 8px;
}

.content-hub-page-chip {
    width: 40px;
    height: 40px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
}

.content-hub-detail-card,
.content-hub-not-found {
    border-radius: 24px;
    padding: 32px;
}

.content-hub-detail-card {
    border: 1px solid rgba(20, 24, 31, 0.08);
    background: #ffffff;
    box-shadow: 0 18px 42px rgba(17, 22, 31, 0.06);
}

.content-hub-detail-title {
    font-size: clamp(2rem, 3.4vw, 3.1rem);
    line-height: 1.14;
}

.content-hub-detail-summary {
    max-width: 820px;
    color: var(--text-light);
    font-size: 1.02rem;
}

.content-hub-detail-visual {
    margin-top: 26px;
    min-height: 320px;
    border-radius: 20px;
}

.content-hub-not-found {
    border: 1px solid rgba(20, 24, 31, 0.08);
    background: #ffffff;
    box-shadow: 0 18px 36px rgba(22, 22, 26, 0.05);
}

.content-hub-detail-body {
    margin-top: 28px;
    padding-top: 28px;
    border-top: 1px solid rgba(20, 24, 31, 0.08);
}

.content-hub-detail-body p + p {
    margin-top: 14px;
}

.content-hub-empty {
    padding: 48px 24px;
    border-radius: 20px;
    border: 1px dashed rgba(20, 24, 31, 0.12);
    text-align: center;
    background: #fafafa;
}

.content-hub-detail-shell {
    display: grid;
    gap: 0;
}

@media (max-width: 992px) {
    .content-hub-list.is-resource,
    .content-hub-card.is-news .content-hub-card-link {
        grid-template-columns: 1fr;
    }

    .content-hub-page-header {
        align-items: start;
    }

    .content-hub-card.is-news .content-hub-card-visual {
        min-height: 220px;
    }
}

@media (max-width: 768px) {
    .content-hub-page-shell {
        padding-top: 112px;
        padding-bottom: 40px;
    }

    .content-hub-card-copy,
    .content-hub-detail-card,
    .content-hub-article,
    .content-hub-not-found {
        padding: 20px;
    }

    .content-hub-page-header {
        margin-bottom: 22px;
        padding-bottom: 18px;
    }

    .content-hub-card-copy h2 {
        font-size: 1.34rem;
    }

    .content-hub-pagination {
        flex-wrap: wrap;
    }

    .content-hub-detail-visual {
        min-height: 220px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/styles/content-hub.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;IAChB,SAAS;IACT,mBAAmB;IACnB,oBAAoB;IACpB,+CAA+C;AACnD;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,wBAAwB;AAC5B;;AAEA;;IAEI,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,qCAAqC;IACrC,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,wBAAwB;IACxB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,SAAS;IACT,mBAAmB;AACvB;;AAEA;;;IAGI,oBAAoB;IACpB,wCAAwC;IACxC,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;;IAEI,6BAA6B;IAC7B,cAAc;IACd,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,gDAAgD;AACpD;;AAEA;IACI,mBAAmB;IACnB,wCAAwC;IACxC,mBAAmB;IACnB,8CAA8C;IAC9C,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;;IAEI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;;IAEI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,0EAA0E;AAC9E;;AAEA;IACI,0EAA0E;AAC9E;;AAEA;IACI,0EAA0E;AAC9E;;AAEA;IACI,0EAA0E;AAC9E;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,qCAAqC;AACzC;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,YAAY;IACZ,aAAa;IACb,SAAS;AACb;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,oBAAoB;IACpB,qCAAqC;AACzC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;IACb,oBAAoB;IACpB,SAAS;IACT,kBAAkB;AACtB;;AAEA;;IAEI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,cAAc;IACd,iBAAiB;IACjB,wBAAwB;AAC5B;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,oBAAoB;IACpB,mBAAmB;IACnB,wBAAwB;IACxB,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;IACI,SAAS;IACT,uBAAuB;IACvB,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;;;;;IAKI,wBAAwB;IACxB,iBAAiB;AACrB;;AAEA;;IAEI,kBAAkB;IAClB,wBAAwB;IACxB,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;;IAEI,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,wCAAwC;IACxC,mBAAmB;IACnB,8CAA8C;AAClD;;AAEA;IACI,qCAAqC;IACrC,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,wBAAwB;IACxB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,wCAAwC;IACxC,mBAAmB;IACnB,8CAA8C;AAClD;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,4CAA4C;AAChD;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,yCAAyC;IACzC,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,MAAM;AACV;;AAEA;IACI;;QAEI,0BAA0B;IAC9B;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,kBAAkB;QAClB,oBAAoB;IACxB;;IAEA;;;;QAII,aAAa;IACjB;;IAEA;QACI,mBAAmB;QACnB,oBAAoB;IACxB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,iBAAiB;IACrB;AACJ","sourcesContent":[".content-hub-page {\r\n    background: #ffffff;\r\n    min-height: 100vh;\r\n}\r\n\r\n.content-hub-page-shell {\r\n    padding-top: 132px;\r\n    padding-bottom: 56px;\r\n}\r\n\r\n.content-hub-page-header {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: end;\r\n    gap: 24px;\r\n    margin-bottom: 28px;\r\n    padding-bottom: 24px;\r\n    border-bottom: 1px solid rgba(20, 24, 31, 0.08);\r\n}\r\n\r\n.content-hub-page-heading {\r\n    max-width: 760px;\r\n}\r\n\r\n.content-hub-kicker {\r\n    display: inline-flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    font-size: 0.78rem;\r\n    font-weight: 700;\r\n    letter-spacing: 0.12em;\r\n    text-transform: uppercase;\r\n    color: var(--accent-red);\r\n}\r\n\r\n.content-hub-page-title,\r\n.content-hub-detail-title {\r\n    margin: 14px 0 12px;\r\n    color: var(--text-main);\r\n}\r\n\r\n.content-hub-page-title {\r\n    font-size: clamp(2.3rem, 4vw, 3.6rem);\r\n    line-height: 1.08;\r\n}\r\n\r\n.content-hub-page-description {\r\n    max-width: 720px;\r\n    color: var(--text-light);\r\n    font-size: 1rem;\r\n    line-height: 1.78;\r\n}\r\n\r\n.content-hub-filter-bar {\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    gap: 12px;\r\n    margin-bottom: 26px;\r\n}\r\n\r\n.content-hub-filter-pill,\r\n.content-hub-page-button,\r\n.content-hub-page-chip {\r\n    border-radius: 999px;\r\n    border: 1px solid rgba(217, 0, 27, 0.12);\r\n    background: #ffffff;\r\n    color: var(--text-main);\r\n    font: inherit;\r\n    cursor: pointer;\r\n    transition: all 0.2s ease;\r\n}\r\n\r\n.content-hub-filter-pill {\r\n    padding: 10px 18px;\r\n    font-weight: 600;\r\n}\r\n\r\n.content-hub-filter-pill.is-active,\r\n.content-hub-page-chip.is-active {\r\n    background: var(--accent-red);\r\n    color: #ffffff;\r\n    border-color: var(--accent-red);\r\n}\r\n\r\n.content-hub-list {\r\n    display: grid;\r\n    gap: 22px;\r\n}\r\n\r\n.content-hub-list.is-resource {\r\n    grid-template-columns: repeat(2, minmax(0, 1fr));\r\n}\r\n\r\n.content-hub-card {\r\n    border-radius: 24px;\r\n    border: 1px solid rgba(20, 24, 31, 0.08);\r\n    background: #ffffff;\r\n    box-shadow: 0 18px 42px rgba(17, 22, 31, 0.06);\r\n    overflow: hidden;\r\n}\r\n\r\n.content-hub-card-link {\r\n    display: grid;\r\n    height: 100%;\r\n    text-decoration: none;\r\n    color: inherit;\r\n}\r\n\r\n.content-hub-card.is-news .content-hub-card-link {\r\n    grid-template-columns: 280px minmax(0, 1fr);\r\n}\r\n\r\n.content-hub-card.is-resource .content-hub-card-link {\r\n    grid-template-columns: 1fr;\r\n}\r\n\r\n.content-hub-card-visual,\r\n.content-hub-detail-visual {\r\n    position: relative;\r\n    overflow: hidden;\r\n}\r\n\r\n.content-hub-card-visual.has-image,\r\n.content-hub-detail-visual.has-image {\r\n    background: #f5f5f5;\r\n}\r\n\r\n.content-hub-cover-image {\r\n    width: 100%;\r\n    height: 100%;\r\n    display: block;\r\n    object-fit: cover;\r\n}\r\n\r\n.content-hub-card.is-news .content-hub-card-visual {\r\n    min-height: 100%;\r\n}\r\n\r\n.content-hub-card.is-resource .content-hub-card-visual {\r\n    min-height: 220px;\r\n}\r\n\r\n.tone-news {\r\n    background: linear-gradient(145deg, #fff4f5 0%, #f9dfe3 52%, #efbcc4 100%);\r\n}\r\n\r\n.tone-talent {\r\n    background: linear-gradient(145deg, #fff8ec 0%, #f5e2be 50%, #e4c17d 100%);\r\n}\r\n\r\n.tone-experts {\r\n    background: linear-gradient(145deg, #f1f6ff 0%, #d6e4fb 50%, #abc3ef 100%);\r\n}\r\n\r\n.tone-service-cases {\r\n    background: linear-gradient(145deg, #f3faf6 0%, #d7eadf 50%, #add1bb 100%);\r\n}\r\n\r\n.content-hub-card-orb {\r\n    position: absolute;\r\n    width: 180px;\r\n    height: 180px;\r\n    border-radius: 50%;\r\n    top: -50px;\r\n    right: -36px;\r\n    background: rgba(255, 255, 255, 0.36);\r\n}\r\n\r\n.content-hub-card-lines {\r\n    position: absolute;\r\n    left: 26px;\r\n    right: 26px;\r\n    bottom: 26px;\r\n    display: grid;\r\n    gap: 10px;\r\n}\r\n\r\n.content-hub-card-lines span {\r\n    display: block;\r\n    height: 10px;\r\n    border-radius: 999px;\r\n    background: rgba(255, 255, 255, 0.82);\r\n}\r\n\r\n.content-hub-card-lines .is-short {\r\n    width: 56%;\r\n}\r\n\r\n.content-hub-card-copy {\r\n    display: grid;\r\n    align-content: start;\r\n    gap: 14px;\r\n    padding: 28px 30px;\r\n}\r\n\r\n.content-hub-card-meta,\r\n.content-hub-detail-meta {\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    align-items: center;\r\n    gap: 10px 14px;\r\n    font-size: 0.9rem;\r\n    color: var(--text-light);\r\n}\r\n\r\n.content-hub-card-badge {\r\n    display: inline-flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    padding: 6px 10px;\r\n    border-radius: 999px;\r\n    background: #fff1f2;\r\n    color: var(--accent-red);\r\n    font-size: 0.78rem;\r\n    font-weight: 700;\r\n    letter-spacing: 0.06em;\r\n    text-transform: uppercase;\r\n}\r\n\r\n.content-hub-card-copy h2 {\r\n    margin: 0;\r\n    color: var(--text-main);\r\n    font-size: 1.5rem;\r\n    line-height: 1.32;\r\n}\r\n\r\n.content-hub-card-copy p,\r\n.content-hub-detail-summary,\r\n.content-hub-article p,\r\n.content-hub-empty,\r\n.content-hub-not-found p {\r\n    color: var(--text-light);\r\n    line-height: 1.84;\r\n}\r\n\r\n.content-hub-card-cta,\r\n.content-hub-back-link {\r\n    width: fit-content;\r\n    color: var(--accent-red);\r\n    font-weight: 700;\r\n    text-decoration: none;\r\n}\r\n\r\n.content-hub-pagination {\r\n    margin-top: 34px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    gap: 12px;\r\n}\r\n\r\n.content-hub-page-button {\r\n    padding: 10px 16px;\r\n}\r\n\r\n.content-hub-page-button:disabled {\r\n    opacity: 0.4;\r\n    cursor: not-allowed;\r\n}\r\n\r\n.content-hub-page-list {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 8px;\r\n}\r\n\r\n.content-hub-page-chip {\r\n    width: 40px;\r\n    height: 40px;\r\n    display: inline-flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n\r\n.content-hub-detail-card,\r\n.content-hub-not-found {\r\n    border-radius: 24px;\r\n    padding: 32px;\r\n}\r\n\r\n.content-hub-detail-card {\r\n    border: 1px solid rgba(20, 24, 31, 0.08);\r\n    background: #ffffff;\r\n    box-shadow: 0 18px 42px rgba(17, 22, 31, 0.06);\r\n}\r\n\r\n.content-hub-detail-title {\r\n    font-size: clamp(2rem, 3.4vw, 3.1rem);\r\n    line-height: 1.14;\r\n}\r\n\r\n.content-hub-detail-summary {\r\n    max-width: 820px;\r\n    color: var(--text-light);\r\n    font-size: 1.02rem;\r\n}\r\n\r\n.content-hub-detail-visual {\r\n    margin-top: 26px;\r\n    min-height: 320px;\r\n    border-radius: 20px;\r\n}\r\n\r\n.content-hub-not-found {\r\n    border: 1px solid rgba(20, 24, 31, 0.08);\r\n    background: #ffffff;\r\n    box-shadow: 0 18px 36px rgba(22, 22, 26, 0.05);\r\n}\r\n\r\n.content-hub-detail-body {\r\n    margin-top: 28px;\r\n    padding-top: 28px;\r\n    border-top: 1px solid rgba(20, 24, 31, 0.08);\r\n}\r\n\r\n.content-hub-detail-body p + p {\r\n    margin-top: 14px;\r\n}\r\n\r\n.content-hub-empty {\r\n    padding: 48px 24px;\r\n    border-radius: 20px;\r\n    border: 1px dashed rgba(20, 24, 31, 0.12);\r\n    text-align: center;\r\n    background: #fafafa;\r\n}\r\n\r\n.content-hub-detail-shell {\r\n    display: grid;\r\n    gap: 0;\r\n}\r\n\r\n@media (max-width: 992px) {\r\n    .content-hub-list.is-resource,\r\n    .content-hub-card.is-news .content-hub-card-link {\r\n        grid-template-columns: 1fr;\r\n    }\r\n\r\n    .content-hub-page-header {\r\n        align-items: start;\r\n    }\r\n\r\n    .content-hub-card.is-news .content-hub-card-visual {\r\n        min-height: 220px;\r\n    }\r\n}\r\n\r\n@media (max-width: 768px) {\r\n    .content-hub-page-shell {\r\n        padding-top: 112px;\r\n        padding-bottom: 40px;\r\n    }\r\n\r\n    .content-hub-card-copy,\r\n    .content-hub-detail-card,\r\n    .content-hub-article,\r\n    .content-hub-not-found {\r\n        padding: 20px;\r\n    }\r\n\r\n    .content-hub-page-header {\r\n        margin-bottom: 22px;\r\n        padding-bottom: 18px;\r\n    }\r\n\r\n    .content-hub-card-copy h2 {\r\n        font-size: 1.34rem;\r\n    }\r\n\r\n    .content-hub-pagination {\r\n        flex-wrap: wrap;\r\n    }\r\n\r\n    .content-hub-detail-visual {\r\n        min-height: 220px;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
